import React from 'react'
import "./visualization.css"
import { PlanetName } from '../../App';
import { planetImages } from '../../utils/planetImagesMap';

export type Planet =
  | "Earth"
  | "Mars"
  | "Mercury"
  | "Venus"
  | "Jupiter"
  | "Saturn"
  | "Uranus"
  | "Neptune";

export type Status = "overview" | "geology" | "structure";

const Visualization = ({selectedCategory, currentPlanet}:{selectedCategory:Status, currentPlanet: PlanetName}) => {
  const data = planetImages[currentPlanet][selectedCategory]   

  return (
    <section id='visualization'>
      <div className='planet-wrapper'>
        <img src={data.main} alt="bla bla bla" />
        {"overlay" in data && (
          <img src={data.overlay} className="overlay" alt="structure" />
        )}
      </div>
    </section>
  )
}

export default Visualization
